import axios from "axios";

export default {
  namespaced: true,
  state: {
    saleschannels: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    saleschannelsMessage: ''
  },
  mutations: {
    CLEAR_DATA(state) {
      state.saleschannels = [];
    },
    RECEIVED_SALESCHANNELS(state, payload) {
      state.saleschannels = payload;
      state.isReceiving = false;
    },
    RECEIVING_SALESCHANNELS(state) {
      state.isReceiving = true;
    },
    RECEIVED_SALESCHANNEL(state, payload) {
      state = Object.assign(state, {
        saleschannels: [...state.saleschannels, payload],
        isReceiving: false,
      })
    },
    RECEIVING_SALESCHANNEL(state) {
      state.isReceiving = true;
    },
    UPDATED_SALESCHANNEL(state, payload) {
      let index = state.saleschannels.findIndex(saleschannel => saleschannel._id === payload._id);
      state = Object.assign(state, {
        saleschannels: state.saleschannels.map((saleschannel, i) => {
          if (i === index) {
            return Object.assign({}, saleschannel, payload);
          }
          return saleschannel;
        }),
        isUpdating: false,
        saleschannelsMessage: 'SalesChannels has been updating!',
      })
    },
    UPDATING_SALESCHANNEL(state) {
      state.isUpdating = true;
    },
    DELETED_SALESCHANNEL(state, payload) {
      let indexToDelete = state.saleschannels.findIndex(saleschannel => saleschannel._id === payload._id);
      let saleschannels = [...state.saleschannels];
      saleschannels.splice(indexToDelete, 1);
      state = Object.assign(state, {
        saleschannels: [...saleschannels],
        isDeleting: false,
        idToDelete: null,
        saleschannelsMessage: 'SalesChannel has been Deleted!',
      });
    },
    DELETING_SALESCHANNEL(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getSalesChannelsRequest({dispatch}) {
      dispatch("receivingSalesChannels");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/saleschannels';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers})
      .then(res => {
        dispatch("receiveSalesChannels", res.data);
      })
    },
    async updateSalesChannelRequest({dispatch}, payload) {
      dispatch("updatingSalesChannel");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/saleschannel/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateSalesChannel", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateSalesChannelImageRequest({dispatch}, payload) {
      dispatch("updatingSalesChannel");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];

      var url = 'https://api.accountxc.com:3100/update/saleschannel/image/' + id;
      let data = new FormData();
      data.append('image', payload.saleschannelimage, payload.imagename); 
      delete payload['saleschannelimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      axios({method: "PUT", url: url,headers: headers,data: data})
      .then(function (res) {
        dispatch("updateSalesChannel", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async insertSalesChannelRequest({dispatch}, payload) {
      dispatch("receivingSalesChannels");
      let url;
      let data;
      let token = localStorage.getItem('token');
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      if(payload.saleschannelimage) {
        url = 'https://api.accountxc.com:3100/insert/saleschannel/withimage';
        data = new FormData();
        data.append('image', payload.saleschannelimage, payload.imagename); 
        delete payload['saleschannelimage'];
        for (let x in payload) {data.append(x, payload[x]);}
      } else {
        url = 'https://api.accountxc.com:3100/insert/saleschannel';
        data = payload;
      }
      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveSalesChannel", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    deleteSalesChannelRequest({dispatch}, payload) {
      dispatch("deletingSalesChannel", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/saleschannel/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteSalesChannel", {_id: payload._id});
      })
    },
    clearChannels({commit}) {
      commit("CLEAR_DATA")
    },
    receiveSalesChannels({commit}, payload) {
      commit("RECEIVED_SALESCHANNELS", payload)
    },
    receivingSalesChannels({commit}) {
      commit("RECEIVING_SALESCHANNELS")
    },
    receiveSalesChannel({commit}, payload) {
      commit("RECEIVED_SALESCHANNEL", payload)
    },
    receivingSalesChannel({commit}) {
      commit("RECEIVING_SALESCHANNEL")
    },
    updateSalesChannel({commit}, payload) {
      commit("UPDATED_SALESCHANNEL", payload)
    },
    updatingSalesChannel({commit}) {
      commit("UPDATING_SALESCHANNEL")
    },
    deleteSalesChannel({commit}, payload) {
      commit("DELETED_SALESCHANNEL", payload)
    },
    deletingSalesChannel({commit}, payload) {
      commit("DELETING_SALESCHANNEL", payload)
    }
  },
};
